import { CSSProperties, ReactNode } from "react";

import { Button } from "@/components/atoms/buttons/Button";
import { TermPolicy } from "@/components/molecules/term-policy/TermPolicy";
import { CtaButtonTypeTemplate } from "@/states/page-editor/template-parts/cta-button";
import { useSetIsAgreePolicy } from "@/states/service-form/operations";
import {
  useIsAgreePolicy,
  useServiceInfo,
} from "@/states/service-form/selectors";
import { contentToHtml } from "@/utils/draft";

interface Props {
  part: CtaButtonTypeTemplate;
  formPath: string | undefined;
  onClick?: () => void;
  disabled?: boolean;
  isShowTerm?: boolean;
}

// part_lp 7
export default function ServiceButtonContent({
  part,
  formPath,
  onClick,
  disabled,
  isShowTerm,
}: Props) {
  const setAgreePolicy = useSetIsAgreePolicy();
  const isAgreePolicy = useIsAgreePolicy();
  const service = useServiceInfo();

  const buttonHref = (): string => {
    if (formPath) {
      return formPath;
    }
    return "";
  };

  const isNewTab = !!(
    part.buttonContent.link?.isNewTab || part.buttonContent.service?.isNewTab
  );

  function ButtonRenderer({
    children,
    styles,
    disabled,
  }: {
    children: ReactNode;
    styles?: CSSProperties;
    disabled?: boolean;
  }) {
    const baseClassNames =
      "text-white cursor-pointer md:transition disabled:pointer-events-none disabled:cursor-default font-bold";
    const largeDoubleArrow = [
      baseClassNames,
      "block box-border !py-[13px] !px-4 !mx-auto !w-full min-h-[72px] rounded border-2 border-solid disabled:opacity-30 transition",
    ].join(" ");
    const linkRef = buttonHref();

    if (disabled) {
      return (
        <div className={largeDoubleArrow + " opacity-50"} style={styles}>
          {children}
        </div>
      );
    }

    return (
      <Button
        className={largeDoubleArrow}
        style={styles}
        href={linkRef}
        onClick={onClick}
        label={children}
        target={isNewTab ? "_blank" : undefined}
      ></Button>
    );
  }

  return (
    <div className="relative flex flex-col gap-6 py-6 px-0 md:p-16">
      {isShowTerm && service && (
        <div id="term-policy">
          <TermPolicy
            serviceId={service.id}
            setIsAgree={setAgreePolicy}
            isAgree={isAgreePolicy}
            isShowTerm={!!service.viewTermFlag}
          />
        </div>
      )}

      {!!part.buttonContent?.content && (
        <div className="m-auto w-full md:max-w-[320px]">
          <ButtonRenderer
            styles={part.buttonContent.cssProperties}
            disabled={disabled}
          >
            <div
              dangerouslySetInnerHTML={{
                __html: contentToHtml(part.buttonContent.content),
              }}
              className="flex flex-col justify-center items-center font-bold leading-[30px] text-[20px]"
              style={part.buttonContent.textBaseStyle}
            />
          </ButtonRenderer>
        </div>
      )}
    </div>
  );
}
